import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminFormDefinitionVersionDetail } from "@/types/form-fields"

export type AdminFormDefinitionVersionDetailState = {
  data: AdminFormDefinitionVersionDetail | null
  error: string | null
}

export const adminFormDefinitionVersionDetailInitialState: AdminFormDefinitionVersionDetailState = {
  data: null,
  error: null,
}

const slice = createSlice({
  name: "adminFormDefinitionVersionDetail",
  initialState: adminFormDefinitionVersionDetailInitialState,
  reducers: {
    setAdminFormDefinitionVersionDetailAction(
      state,
      { payload }: PayloadAction<AdminFormDefinitionVersionDetail | null>,
    ) {
      state.data = payload
      state.error = null
    },
    setAdminFormDefinitionVersionDetailErrorAction(
      state,
      { payload }: PayloadAction<string | null>,
    ) {
      state.error = payload
    },
  },
})

export const {
  setAdminFormDefinitionVersionDetailAction,
  setAdminFormDefinitionVersionDetailErrorAction,
} = slice.actions
export default slice.reducer
